import React, { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import "./reset-password.scss";
import { calls } from "../../config/db_config";
import { BiLockAlt } from "react-icons/bi";
import { iconStyle } from "../../utils/generalUtils";

const ResetPassword = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token"); // Get token from URL
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [logoLink, setLogoLink] = useState("");
  const [failed, setFailed] = useState(false);

  const [userId, setUserId] = useState();

  useEffect(() => {
    if (!token) {
      setMessage("Invalid reset link.");
    }
  }, [token]);

  useEffect(() => {
    getEnvironment();
  }, []);

  useEffect(() => {
    console.log(token);
    chechToken();
  }, [token]);

  const getEnvironment = () => {
    fetch(calls.getLogoLink, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        // Authorization: tokenUtils.getBearerToken(),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 200) {
          setLogoLink(data.data);
        }
      });
  };

  const chechToken = () => {
    let args = "?token=" + token;
    fetch(calls.getResetValidity + args, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        // Authorization: tokenUtils.getBearerToken(),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        console.log(" got data from backend ");
        console.log(data);
        if (data.data && data.data[0] && data.data[0].user_id) {
          setUserId(data.data[0].user_id);
        } else {
          setFailed(true);
        }
      });
  };

  const handleResetPassword = async (e) => {
    e.preventDefault();

    if (!password || !confirmPassword) {
      setMessage("Please fill in both fields.");
      return;
    }

    if (password !== confirmPassword) {
      setMessage("Passwords do not match.");
      return;
    }

    setLoading(true);
    setMessage("");

    const data = {
      password: password,
      user_id: userId,
    };

    fetch(calls.resetPassword, {
      method: "post",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.message) {
          if (data.message == "password-reset-success") {
            setIsLoading(false);
          } else {
            setIsLoading(false);
          }
        }
      });
    setLoading(false);
  };

  return (
    <div className="reset-password">
      <div className="reset-password__container">
        <div className="reset-password__container-logo">
          <img src={logoLink} alt="school-logo" />
        </div>

        {message && <p className="message">{message}</p>}

        <form className="reset-password__form" onSubmit={handleResetPassword}>
          <div className="reset-password__form-item">
            <span>New Password</span>
            <div className="reset-password__input">
              <BiLockAlt
                size={"30px"}
                color={"#6225e6"}
                style={iconStyle("transparent")}
              />
              <input
                type="password"
                placeholder="Κωδικός"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>
          <div className="reset-password__form-item">
            <span>Confirm Password</span>
            <div className="reset-password__input">
              <BiLockAlt
                size={"30px"}
                color={"#6225e6"}
                style={iconStyle("transparent")}
              />
              <input
                type="password"
                placeholder="Επανάληψη κωδικού"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>
          </div>

          <button className="cta cta-fill" type="submit" disabled={loading}>
            {loading ? "Resetting..." : "Reset Password"}
          </button>
        </form>
      </div>
      <div className="start-page__graphic">
        <div className={"edupal-logo " + (isLoading ? "loading" : "")}>
          {window.location.hostname.includes("lingopowers") ? (
            <img
              className="white-label small"
              src={"lingopowers.png"}
              alt="lingopowers-logo"
            />
          ) : (
            <img src={"logo_white.png"} alt="edupal-logo" />
          )}
        </div>
        <div
          className={
            "circle third " +
            (window.location.hostname.includes("lingopowers")
              ? " purple "
              : "") +
            +(isLoading ? "loading" : "")
          }
        ></div>
        <div
          className={
            "circle second " +
            (isLoading ? "loading" : "") +
            (window.location.hostname.includes("lingopowers") ? " blue" : "")
          }
        ></div>
        <div
          className={
            "circle fourth " +
            (window.location.hostname.includes("lingopowers")
              ? " orange"
              : "") +
            (isLoading ? "loading" : "")
          }
        ></div>
        <div
          className={
            "circle first " +
            (isLoading ? "loading" : "") +
            (window.location.hostname.includes("lingopowers") ? " orange" : "")
          }
        ></div>
      </div>
    </div>
  );
};

export default ResetPassword;
